module.exports = __webpack_public_path__ + "img/New Hampshire outline.d80eec8a.png";